import React from "react";
import logo from "../assets/logo.png";
import queriIcon from "../assets/queri-icon.png";
import { useI18n } from "../i18n";

/**
 * A co-branding credit for workspace surfaces: the workspace owns the header,
 * Queri keeps a present — but subordinate — mark as a "Powered by" band at the
 * foot of the sidebar. A divider sets it apart from the user row so it reads as
 * a deliberate credit rather than an afterthought; the real Queri logo runs at
 * full strength, centered. Collapses to just the Queri icon in icon mode.
 * Render only inside a workspace. See RFC 008 (Workstream B).
 */
export const PoweredByQueri: React.FC = () => {
  const { t } = useI18n();
  return (
    <div className="flex items-center justify-center gap-2 border-t border-sidebar-border/60 px-2 pt-2.5 pb-1.5 group-data-[collapsible=icon]:border-t-0 group-data-[collapsible=icon]:px-0">
      <span className="text-[11px] tracking-wide text-sidebar-foreground/60 group-data-[collapsible=icon]:hidden">
        {t.nav.poweredBy}
      </span>
      <img
        src={logo}
        alt="Queri"
        className="h-5 group-data-[collapsible=icon]:hidden"
      />
      <img
        src={queriIcon}
        alt="Queri"
        className="mx-auto hidden h-5 w-5 group-data-[collapsible=icon]:block"
      />
    </div>
  );
};
